export const MAX_SIZE_TAG = 50;
